module.exports = __webpack_public_path__ + "static/img/3.5149de0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/f1/3.gif
// module id = f/ma
// module chunks = 1